/* Static option / label maps for the manual content transformations screen. */

export const CONTENT_TRANSFORMATION_PATH =
  '/dashboard/ai-automation/flow-builder/manual-content-transformations';

export const LANGUAGE_OPTIONS = [
  {value: 'EN', label: 'English'},
  {value: 'FR', label: 'French'},
];

export const LANGUAGE_LABEL = {
  EN: 'English',
  FR: 'French',
};

/*
 * The GraphQL enum is what we send. The internal n8n identifier is listed only
 * so the mapping stays traceable against the backend contract — it is never
 * sent from here.
 */
export const CHANNEL_GROUPS = [
  {
    key: 'social',
    title: 'Social posts',
    channels: [
      {value: 'X', label: 'X'}, // xPost
      {value: 'FACEBOOK', label: 'Facebook'}, // facebookPost
      {value: 'LINKEDIN', label: 'LinkedIn'}, // linkedinPost
      {value: 'INSTAGRAM_POST', label: 'Instagram post'}, // instagramPost
      {value: 'PINTEREST', label: 'Pinterest'}, // pinterestPost
    ],
  },
  {
    key: 'carousels',
    title: 'Carousels',
    channels: [
      {value: 'INSTAGRAM_CAROUSEL', label: 'Instagram carousel'}, // instagramCarousel
      {value: 'TIKTOK_CAROUSEL', label: 'TikTok carousel'}, // tiktokCarousel
    ],
  },
  {
    key: 'video',
    title: 'Video and YouTube',
    channels: [
      {value: 'TIKTOK_VIDEO', label: 'TikTok video'}, // tiktokVideo
      {value: 'YOUTUBE_VIDEO_SCRIPT', label: 'YouTube video script'}, // youtubeVideoScript
      {value: 'YOUTUBE_POST', label: 'YouTube post'}, // youtubePost
    ],
  },
  {
    key: 'publishing',
    title: 'Publishing',
    channels: [
      {value: 'WEBSITE_NEWS', label: 'Website news'}, // publishWebNews
      {value: 'WORDPRESS_ARTICLE', label: 'WordPress article'}, // publishArticle
    ],
  },
];

export const CHANNEL_LABEL = CHANNEL_GROUPS.reduce((acc, group) => {
  group.channels.forEach(channel => {
    acc[channel.value] = channel.label;
  });
  return acc;
}, {});

/*
 * `DISPATCHED` means n8n accepted the webhook — it is deliberately labelled
 * "Running" and never "Successful" / "Completed".
 */
export const STATUS_META = {
  PENDING: {label: 'Queued', color: 'gold'},
  DISPATCHED: {label: 'Running', color: 'blue'},
  PROCESSED: {label: 'Completed', color: 'green'},
  FAILED: {label: 'Failed', color: 'red'},
};

/** Statuses that will never change again — polling stops once all rows are here. */
export const TERMINAL_STATUSES = ['PROCESSED', 'FAILED'];

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ['20', '50', '100'];
export const POLL_INTERVAL_MS = 10000;
export const SEARCH_DEBOUNCE_MS = 400;

export const MAX_TITLE_LENGTH = 300;
export const MAX_CONTENT_LENGTH = 50000;
export const MAX_SOURCE_URL_LENGTH = 2048;
export const MAX_SEARCH_LENGTH = 200;

export const EMPTY_FORM_VALUES = {
  title: '',
  content: '',
  sourceUrl: '',
  languages: ['EN'],
  channels: [],
};
